

















































































































import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import ImageModal from "@/components/ImageModal.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import ConversationsApi from "@/services/Conversations";
import MessagesApi from "@/services/Messages";
import UgcsApi from "@/services/Ugcs";
import AuthModule from "@/store/auth";
import {
  ConversationByAdmin,
  Message,
  NewConversations,
  NewMessages,
  Organization,
  SortDirection,
  UGC,
} from "@/api/lab-base-api-client";
import { io } from "socket.io-client";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import ja from "dayjs/locale/ja";
import VueRouter, { NavigationGuardNext } from "vue-router";
import OrganizationApi from "@/services/Organizations";
import logger from "@/lib/log/logger";
import fileDownload from "js-file-download";

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  components: {
    Header,
    ImageModal,
  },
})
export default class MChat extends CheckAdminLogin {
  private userFilterList: { name: string; uuid: string }[] = [
    { name: "全て", uuid: "all" },
    { name: "一般ユーザー", uuid: "user" },
    { name: "担当団体", uuid: "representative" },
  ];

  private messages: Message[] = [];

  private messageForm: NewMessages = {
    conversationUuid: "",
    senderUuid: "",
    text: "",
  };

  private conversationUserUuid = "";

  private conversations: ConversationByAdmin[] = [];

  private conversationIndex: null | number = null;

  private conversationForm: NewConversations = {
    userUuid: "",
    adminUuid: "",
  };

  private UGC: UGC[] = [];

  private adminUuid = process.env.VUE_APP_ADMIN_UUID_FOR_REPLY ? process.env.VUE_APP_ADMIN_UUID_FOR_REPLY : "";

  private file: File | null = null;

  // v-textarea(message-input)の行数
  private textareaRow = 1;

  // private position = 0;

  // 表示メッセージ件数 初期値：30
  private viewMessageNum = 30;

  private organizations: Organization[] = [];

  private isChatImgModal = false;

  private src: string | null = null;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private socket = io(
    `${process.env?.NODE_ENV === "development" ? "http://localhost:3000" : process.env.VUE_APP_SOCKET_URL}`,
    {
      withCredentials: true,
      path: `${process.env?.NODE_ENV === "development" ? "" : "/api/socket.io"}`,
    }
  );

  // queryの変更で実行
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async beforeRouteUpdate(to: Record<string, any>, from: VueRouter, next: NavigationGuardNext) {
    await this.read(to.query.uuid);
    await this.fetchMessages(to.query.uuid);
    this.displayLatestChat();
    next();
  }

  private async mounted() {
    this.socket.on("sendConversationUuid", () => {
      if (this.$route.name === "MChat") {
        this.fetch();
      }
    });

    dayjs.extend(relativeTime);
    dayjs.locale(ja);

    this.resize();
    // this.getScroll();
    await this.fetch();
    this.displayLatestChat();
  }

  // 画像モーダルの表示
  private async openImgModal(event: Event) {
    if (!event) {
      return;
    }
    this.isChatImgModal = true;
    this.src = (event?.target as HTMLImageElement).src;
  }

  // チャットに関する情報の取得
  private async fetch() {
    if (!this.me) {
      return;
    }

    await Promise.all([this.fetchAllConversations(), this.fetchUserFilter()]);

    if (!this.$route.query.uuid) {
      await this.$router.push({ name: "MChat", query: { uuid: this.conversations[0].uuid } });
    } else {
      await this.read(String(this.$route.query.uuid));
      await this.fetchMessages(String(this.$route.query.uuid));
    }
  }

  private async fetchOrganizationConversations(organizationUuid: string) {
    const conversationsByOrganizationRes = await ConversationsApi.instance.getConversationByOrganizationAdminUuid(
      organizationUuid
    );
    this.setConversations(conversationsByOrganizationRes.data.data.items);
  }

  // 全てのconversation取得
  private async fetchAllConversations() {
    const conversationsRes = await ConversationsApi.instance.getConversationByAdminUuid(this.adminUuid);
    this.setConversations(conversationsRes.data.data.items);
  }

  private async setConversations(conversations: ConversationByAdmin[]) {
    if (!conversations.length) {
      return;
    }
    const hasMessageConversations = conversations.filter((conversation: ConversationByAdmin) => {
      return conversation.messages[0];
    });

    // sidebarのuserを新規メッセージ順に並び替え
    this.conversations = hasMessageConversations.sort((a, b) => {
      if (a.messages[0].createdAt < b.messages[0].createdAt) {
        return 1;
      }
      return -1;
    });
  }

  // サイドバーの絞り込み条件情報取得
  private async fetchUserFilter() {
    const organizationsRes = await OrganizationApi.instance.getOrganizations();
    this.organizations = organizationsRes.data.data.items;
    const formatOrganizations = organizationsRes.data.data.items.map((organization: Organization) => {
      return { name: organization.name, uuid: organization.uuid };
    });

    this.userFilterList = this.userFilterList.concat(formatOrganizations);
  }

  // ユーザー絞り込み変更時に実行
  private async changeUserFilter(value: string) {
    this.conversations = [];

    if (value === "all") {
      this.fetchAllConversations();
    } else if (value === "user") {
      await this.fetchAllConversations();
      this.conversations = this.conversations.filter((conversation: ConversationByAdmin) => {
        return conversation.user.roleId === 2;
      });
    } else if (value === "representative") {
      const filterOrganizationUuids = this.organizations.flatMap((organization: Organization) => {
        return organization.itnavRepresentative === this.me?.uuid ? organization.uuid : [];
      });
      filterOrganizationUuids.forEach(async (filterOrganizationUuid: string) => {
        const conversationsByOrganizationRes = await ConversationsApi.instance.getConversationByOrganizationAdminUuid(
          filterOrganizationUuid
        );
        const conversations = conversationsByOrganizationRes.data.data.items;
        if (!conversations.length) {
          return;
        }
        const hasMessageConversations = conversations.filter((conversation: ConversationByAdmin) => {
          return conversation.messages[0];
        });

        this.conversations = this.conversations.concat(hasMessageConversations);
      });

      // 並び替え
      this.conversations.sort((a, b) => {
        if (a.messages[0].createdAt < b.messages[0].createdAt) {
          return 1;
        }
        return -1;
      });
    } else {
      this.fetchOrganizationConversations(value);
    }
  }

  // 最新のチャットを表示
  private displayLatestChat() {
    if (this.$refs.inner) {
      (this.$refs.inner as Element).scrollIntoView(false);
    }
  }

  /**
   * 最後のメッセージから現在までの差分を表示
   */
  private displayNowFromMessages(createdAt: string) {
    return dayjs(createdAt).fromNow();
  }

  // メッセージの取得
  private async fetchMessages(conversationUuid: string) {
    const messagesRes = await MessagesApi.instance.getMessage(
      conversationUuid,
      this.viewMessageNum,
      undefined,
      SortDirection.Desc
    );
    const messages = messagesRes.data.data.items;
    messages.sort((a, b) => {
      if (a.createdAt > b.createdAt) {
        return 1;
      }
      return -1;
    });

    this.messages = messages;

    // 既読後の最新messageをconversationに代入
    const index = this.conversations.findIndex(({ uuid }) => {
      return uuid === conversationUuid;
    });
    this.conversations[index].messages[0] = messages[messages.length - 1];

    this.conversationUserUuid = this.conversations[index].userUuid;
  }

  // 既読
  private async read(conversationUuid: string) {
    try {
      await MessagesApi.instance.patchReadFlag(this.adminUuid, conversationUuid);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  // 送信
  private async submit(conversationUuid: string) {
    // 送信処理
    if (!this.me) {
      return;
    }
    this.messageForm.senderUuid = this.me.uuid;

    // text内のlinkを検出し変換
    const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
    const regexpMakeLink = (url: string) => {
      return `<a class="link" href="${url}">${url}</a>`;
    };

    this.messageForm.text = this.messageForm.text.replace(regexpUrl, regexpMakeLink);
    this.messageForm.conversationUuid = conversationUuid;

    // UGCが一つ以上ある場合ugcTypeを検証し適した形に変換
    if (this.UGC.length > 0) {
      let files = "";
      for (let i = 0; i < this.UGC.length; i += 1) {
        if (this.UGC[i].ugcType === "image") {
          files += `<img src="${this.UGC[i].url}" class="chat-img">`;
        } else if (this.UGC[i].ugcType === "zip") {
          files += `<div class="file-wrap download" data-ugc-uuid="${this.UGC[i].uuid}"><i class="v-icon file-icon fa fa-solid fa-file-download"></i><div class="file-name">${this.UGC[i].metadata.originalname}</div></div>`;
        }
      }

      if (this.messageForm.text) {
        this.messageForm.text += `<div class="files mt-3">${files}</div>`;
      } else {
        this.messageForm.text += `<div class="files">${files}</div>`;
      }
      await MessagesApi.instance.postMessage(this.messageForm);

      this.UGC = await [];
    } else if (this.messageForm.text !== "") {
      await MessagesApi.instance.postMessage(this.messageForm);
    }

    this.socket.emit("sendMessage", this.messageForm.conversationUuid);
    this.messageForm.text = "";
    await this.fetchMessages(conversationUuid);
    this.displayLatestChat();
  }

  // UGCの中身から対応した情報を削除することでUGCモーダルのclose機能を実装
  private async closeUgcModal(i: number) {
    this.UGC.splice(i, 1);
    if (this.file) {
      this.file = null;
    }
  }

  private async postUGC() {
    if (this.file) {
      const ugc = await this.createUgc(this.file);
      this.UGC.push(ugc);
      this.file = null;
    }
  }

  // messagesの中身が変わるごとにchat上のUGCファイルにダウンロード機能を付与
  @Watch("messages")
  private async attachDownload() {
    const downloadBtns = document.querySelectorAll(".download");
    if (downloadBtns.length > 0) {
      downloadBtns.forEach((elem: Element) => {
        elem.addEventListener("click", this.download);
      });
    }
  }

  // 画像モーダル表示機能を有効にするためのクリックイベントの付与
  @Watch("messages")
  private attachClickEvent() {
    const imgElements = document.querySelectorAll(".chat-img");
    if (imgElements.length > 0) {
      imgElements.forEach(elem => {
        elem.addEventListener("click", this.openImgModal);
      });
    }
  }

  // UGCダウンロード機能
  private async download(e: Event) {
    try {
      const element = e.currentTarget as HTMLInputElement;
      const targetUuid = element.dataset.ugcUuid;
      const ugcData = await UgcsApi.instance.getUGC(targetUuid as string);
      const ugcRes = await UgcsApi.instance.getDownloadUGC(targetUuid as string, { responseType: "blob" });
      fileDownload(ugcRes.data, ugcData.data.data.ugc.metadata.originalname);
    } catch (err) {
      console.log(err);
    }
  }

  // UGC作成
  private async createUgc(file: File) {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(file);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed create ugc");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      throw err;
    }
  }

  // 下からのスクロール位置の取得
  // private getScroll() {
  //   const chatContent = this.$refs.chatContent as Element;
  //   chatContent.addEventListener("scroll", () => {
  //     this.position = chatContent.scrollHeight - chatContent.scrollTop - chatContent.clientHeight;
  //   });
  // }

  @Watch("messageForm.text")
  private changeTextareaRow() {
    this.resize();
  }

  /**
   * リサイズ
   */
  private async resize() {
    this.textareaRow = 1;
    await this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const height = (this.$refs.textarea as any).$el.querySelector("textarea").scrollHeight;

      // 84 = テキストエリアの高さ、row3つ分
      // 3行分以上の高さの場合、3をtextareaRowに代入
      if (height >= 84) {
        this.textareaRow = 3;
      } else if (height > 32) {
        // 2行分の高さの場合、2をtextareaRowに代入
        this.textareaRow = 2;
      } else {
        // 1行分の高さの場合1をtextareaRowに代入
        this.textareaRow = 1;
      }
    });
  }

  /**
   * urlが含まれている場合、リンクに変換してメッセージを表示
   */
  private displayMessage(message: string) {
    const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
    const regexpMakeLink = (url: string) => {
      return `<a class="link" href="${url}">${url}</a>`;
    };

    return message.replace(regexpUrl, regexpMakeLink);
  }

  /**
   * chatContentScrollのscrollTopが0になるまでスクロールで、メッセージの取得件数を増やす
   * メッセージの追加読み込み時に表示位置を変更しない
   */
  private async onScroll() {
    const chatContentElement = this.$refs.chatContent as Element;
    /**
     * チャットを取得する前の要素の高さ
     * ここで高さを定義することでオブジェクトの参照によるコピーを回避し、値としてコピーする
     */
    const beforeChatContentScrollHeight = chatContentElement.scrollHeight;
    if (chatContentElement.scrollTop === 0) {
      this.viewMessageNum += 30;
      await this.fetchMessages(String(this.$route.query.uuid));
      // チャットを取得した後とチャットを取得する前の要素の高さの差
      const scrollHeightDiff = chatContentElement.scrollHeight - beforeChatContentScrollHeight;
      // メッセージの追加読み込み時に表示位置を変更しない
      chatContentElement.scrollTo(0, scrollHeightDiff);
    }
  }
}
